import React, { PropsWithChildren } from 'react';
import styles from './SubsectionTitle.module.scss';

export function SubsectionContent({ children }: PropsWithChildren) {
  return <p className={styles.subsectionContent}>{children}</p>;
}
